import React, { Component } from 'react';
import ReactApexChart from 'react-apexcharts';
import {
  labelStyle,
  tooltip,
  stroke,
  lineXaxis,
  markers,
} from '../options';
import { getDatesRange } from '../utils';
import dict from '../../dictionary';
import trans from '../../translations.json';
import ReducedData from '../../reducedData.json';
import FuzySearch from '../fuzySearch/fuzySearch';
import { Checkbox } from 'antd';
import '../buttonGroup/buttonGroup.scss';
import compareChartColours from '../compareChart/compareChart.scss';
import SearchResultsDropdown from '../search/searchResultDropdown';
import { SelectionLimitReached } from '../compareChart/compareChartUtils';
import moment from 'moment';
import CvizRadioGroup from '../cvizRadioGroup/cvizRadioGroup';

const numResults = 3,
  latestDate = Object.values(ReducedData.statusOfCasesPhu)
    .reverse()[0]
    .FILE_DATE.toString();

const formattedDate = [
  latestDate.slice(0, 4),
  latestDate.slice(4, 6),
  latestDate.slice(6, 8),
].join('-');

const chartColours = [
    compareChartColours.compareChartColour1,
    compareChartColours.compareChartColour2,
    compareChartColours.compareChartColour3,
    compareChartColours.compareChartColour4,
    compareChartColours.compareChartColour5,
  ],
  dateRange = getDatesRange('2020-04-01', formattedDate);

const data = Object.keys(ReducedData.dataPHU).reduce(
  (sum, currPHU) => {
    return sum.concat(
      ReducedData.dataPHU[currPHU].cities.map((city) => {
        return {
          city_name: city,
          phu_name: ReducedData.dataPHU[currPHU][dict.Reporting_PHU],
        };
      }),
    );
  },
  [],
);

const phuData = Object.values(ReducedData.statusOfCasesPhu);

let phuNum = {};

class PhuStatusGraph extends Component {
  state = {
    ready: false,
    keys: Object.keys(ReducedData.dataPHU),
    selection: [
      'Algoma Public Health Unit',
      'Brant County Health Unit',
      'Chatham-Kent Health Unit',
      null,
      null,
    ],
    selectionColors: chartColours,
    series: [],
    perCapita: false,
    selectionLimitReached: false,
    options: {},
    searchQuery: '',
    searchQueryTime: +Date.now(),
    searchResults: [],
    highlighted: [],
  };

  componentDidMount() {
    this.setData();
  }

  componentDidUpdate(prevProps, prevState) {
    if (
      this.state.selection !== prevState.selection ||
      this.props.selectedTab !== prevProps.selectedTab ||
      this.state.perCapita !== prevState.perCapita
    ) {
      this.setData();
    }
  }

  zeroSelection = () => {
    this.setState({
      selectionLimitReached: false,
      selection: [null, null, null, null, null],
    });
  };

  toggleSelectionOfPHU = (name) => {
    var selection = [...this.state.selection];

    //check if it's already selected
    var currentSelectionKey = selection.indexOf(name);
    var availForSelection = selection.indexOf(null);

    //if already selected toggle off
    if (currentSelectionKey !== -1) {
      selection[currentSelectionKey] = null;

      //if not selected and available set it
    } else if (availForSelection !== -1) {
      selection[availForSelection] = name;
    }

    const newSelectionColors = [...chartColours].filter(
      (color, ind) => selection[ind],
    );

    this.setState({
      selectionLimitReached:
        currentSelectionKey === -1 && availForSelection === -1,
      selection: selection,
      selectionColors: newSelectionColors,
    });
  };

  onTabChange = (tabName) => {
    this.setState({
      selectedTab: tabName,
    });
  };

  togglePerCapita = (e) => {
    this.setState({
      perCapita: e,
    });
  };

  setSearchResults = () => {
    setTimeout(
      () =>
        this.setState({
          searchResults: [],
        }),
      200,
    );
  };

  formatDate = (date) => {
    return [
      date.slice(0, 4),
      date.slice(4, 6),
      date.slice(6, 8),
    ].join('-');
  };

  prepData = () => {
    ReducedData.dataTesting.forEach((item) => {
      if (!Object.keys(phuNum).includes(item.PHU_num)) {
        for (var key in dict.PHUs) {
          if (dict.PHUs[key] === item.PHU_name) {
            phuNum[item.PHU_num] = key;
          }
        }
      }
    });
    phuNum[2268] = 'Windsor-Essex County Health Unit';

    let preppedData = {};

    phuData.forEach((item) => {
      let formattedDate = this.formatDate(item.FILE_DATE.toString());

      if (!Object.keys(preppedData).includes(formattedDate)) {
        let data = {};

        Object.keys(phuNum).forEach((phu) => {
          if (Number(phu) === Number(item.PHU_NUM)) {
            data[phu] = { status: item[this.props.field] };
          } else {
            data[phu] = { status: -100 };
          }
        });

        preppedData[formattedDate] = { ...data };
      } else {
        Object.keys(phuNum).forEach((phu) => {
          if (Number(phu) === Number(item.PHU_NUM)) {
            preppedData[formattedDate][phu].status =
              item[this.props.field];
          }
        });
      }
    });
    return preppedData;
  };

  setData = () => {
    let preppedData = { ...this.prepData() };
    let show = Boolean(
      this.state.selection.reduce((sum, sel) => sum + sel),
    );
    var state = this.state;
    var series = [...this.state.selection]
      .filter((item) => item)
      .map((name, z) => {
        var accum = 0;
        return {
          name: name,
          data: [...dateRange].map((date, idx) => {
            const newDate = new Date(
              moment(date).utcOffset('-05:00'),
            ).getTime();
            let num;
            for (var key in phuNum) {
              if (phuNum[key] === name) {
                num = key;
              }
            }
            var value = preppedData[date][num].status || 0,
              result,
              pop = ReducedData.dataPHU[name].PHU_pop;
            accum = Number(accum) + Number(value);

            switch (this.props.selectedTab) {
              case 'newCases':
                if (!state.perCapita) {
                  result = value;
                } else {
                  result = ((Number(value) / pop) * 100000).toFixed(
                    2,
                  );
                }
                break;
              case 'totalCases':
                if (!this.state.perCapita) {
                  result = accum;
                } else {
                  result = ((accum / pop) * 100000).toFixed(2);
                }
                break;
              default:
            }

            return [newDate, result];
          }),
        };
      });

    //debugger;
    this.setState({
      masterSeries: series,
      series: [...series],
      options: {
        colors: this.state.selectionColors,
        markers: markers,
        stroke: stroke,
        legend: {
          show: false,
        },
        tooltip: tooltip,
        chart: {
          animations: {
            enabled: false,
            animateGradually: {
              enabled: false,
            },
            dynamicAnimation: {
              enabled: false,
            },
          },
          type: 'line',
          toolbar: {
            show: true,
            tools: {
              download: false,
              selection: false,
              zoom: false,
              zoomin: false,
              zoomout: false,
              pan: false,
              reset: false,
            },
          },
          zoom: { enabled: true },
        },
        plotOptions: {
          bar: {
            horizontal: false,
          },
        },
        dataLabels: {
          enabled: false,
        },
        yaxis: {
          title: {
            text: trans.bySource.yaxis[this.props.lang],
          },
          decimalsInFloat: this.state.perCapita ? 2 : 0,
          labels: {
            style: { ...labelStyle },
            formatter: (value) =>
              this.props.lang === 'fr'
                ? value.toLocaleString()
                : value
                    .toString()
                    .replace(/\B(?=(\d{3})+(?!\d))/g, ','),
          },
        },
        xaxis: { ...lineXaxis(show) },
        responsive: [
          {
            breakpoint: 640,
            options: {
              chart: {
                height: '200px',
              },
            },
          },
        ],
        // fill: {
        //   opacity: [0.2, 1],
        // },
      },
      ready: true,
    });
  };

  /**
   * Sets search data state after Fuze returns a new search
   */
  searchResultsCallback = (e, results) => {
    this.setState({
      searchQuery: e,
      highlighted: [],
      searchResults: results ? results.slice(0, numResults) : [],
    });
  };

  /**
   * Highlights a specified PHU pill
   */
  onClickSearchResult = (phu_name) => {
    // if (!this.state.highlighted.includes(phu_name)) {
    this.setState({
      highlighted: [phu_name],
      searchResults: [],
      searchQuery: phu_name,
      searchQueryTime: +Date.now(),
    });
    this.toggleSelectionOfPHU(phu_name);
    //}
  };

  hideDropdown = () => {
    this.setState({ searchResults: [] });
  };

  clearHighlight = (name) => {
    if (this.state.highlighted.includes(name))
      this.setState({
        highlighted: [],
      });
  };

  render() {
    const searchOpts = {
      includeMatches: true,
      keys: ['city_name'],
    };
    const lang = this.props.lang;
    const CheckboxesNames = () =>
      Object.keys(trans.PHU)
        .map((item) => {
          return {
            name: item,
          };
        })
        .sort((a, b) => a.name.localeCompare(b.name))
        .map((item, key) => {
          var selectionKey = this.state.selection.includes(item.name)
            ? `compare-chart-${this.state.selection.indexOf(
                item.name,
              )}`
            : '';
          var highlighted = this.state.highlighted.includes(item.name)
            ? `compare-chart-highlighted`
            : '';
          return (
            <Checkbox
              checked={this.state.selection.includes(item.name)}
              onClick={() => this.toggleSelectionOfPHU(item.name)}
              className={`${selectionKey} ${highlighted}`}
              onMouseEnter={() => this.clearHighlight(item.name)}
              key={key}
            >
              {trans.PHU[item.name][lang]}
            </Checkbox>
          );
        });

    return (
      <div
        id="compare-chart-"
        className="chart ontario-columns  ontario-margin-bottom-32-! "
      >
        {this.state.ready ? (
          <>
            <div
              id="compare-chart-controls"
              className="ontario-row ontario-margin-bottom-8-!"
            >
              <CvizRadioGroup
                onChange={this.togglePerCapita}
                value={this.state.perCapita}
                optionsName={'phu'}
                className={'cviz-radioGroup-noflex'}
                cases={[
                  [
                    false,
                    trans.general.numberOfCases[this.props.lang],
                  ],
                  [true, trans.overview.per100K[this.props.lang]],
                ]}
              />
            </div>
            <ReactApexChart
              options={this.state.options}
              series={this.state.series}
              height={400}
              aria-hidden="true"
            />
            <div
              id="fuzzySearch"
              className="ontario-row ontario-margin-top-16-! ontario-margin-bottom-16-!"
            >
              {data.length && (
                <div
                  className="ontario-columns ontario-small-12 ontario-medium-4"
                  style={{ position: 'relative' }}
                >
                  <div className="ontario-row">
                    <p>
                      <b>{trans.phu.search[this.props.lang]}</b>
                    </p>
                    <FuzySearch
                      onBlur={this.setSearchResults}
                      searchQuery={this.state.searchQuery}
                      searchQueryTime={this.state.searchQueryTime}
                      searchResultsCallback={
                        this.searchResultsCallback
                      }
                      data={data}
                      minSearchLength={3}
                      searchSettings={searchOpts}
                      searchLabel={
                        trans.heatmap.city[this.props.lang]
                      }
                    />
                    <SearchResultsDropdown
                      results={this.state.searchResults}
                      handleOnClick={this.onClickSearchResult}
                      hideDropdown={this.hideDropdown}
                    />
                  </div>
                </div>
              )}
            </div>
            <div
              id="phuCheckboxes"
              className="ontario-row ontario-margin-bottom-16-!"
            >
              <div className="ontario-margin-top-8-! ">
                <div className="ontario-row">
                  <p>{trans.phu.select[this.props.lang]}</p>
                  <SelectionLimitReached
                    lang={this.props.lang}
                    visible={this.state.selectionLimitReached}
                    onOk={() =>
                      this.setState({ selectionLimitReached: false })
                    }
                    onCancel={this.zeroSelection}
                  />

                  <div id="" className="viz-chart-checkboxes ">
                    <CheckboxesNames />
                  </div>
                </div>
              </div>
            </div>
          </>
        ) : (
          ''
        )}
      </div>
    );
  }
}
export default PhuStatusGraph;
